import { z } from "zod";

export const zCaptionsSubscriptionPlan = z.enum([
  "free",
  "lite",
  "pro",
  "max",
  "scale",
  "scale2x",
  "scale4x",
  "enterprise",
  "business",
  "teams",
]);

const zMirageStudioSubscriptionPlan = z.enum([
  "enterprise",
  "business",
  "teams",
  "pro",
  "max",
  "scale",
  "scale2x",
  "scale4x",
]);

const CreditsRefreshConfig = z.object({
  refreshType: z.enum(["weekly", "monthly", "yearly"]),
  refreshAmount: z.number(),
});

const CreditsLimitConfig = z.object({
  initialAccountCreditsAmount: z.number(),
});

const CreditsConfig = z.object({
  creditsRefreshConfig: CreditsRefreshConfig.optional(),
  creditsLimitConfig: CreditsLimitConfig,
});
type CreditsConfig = z.infer<typeof CreditsConfig>;
export type CreditsRefreshConfig = z.infer<typeof CreditsRefreshConfig>;

export const SubscriptionStoreSchema = z.enum([
  "app_store",
  "play_store",
  "mac_app_store",
  "amazon",
  "stripe",
  "promotional",
]);
export type SubscriptionStore = z.infer<typeof SubscriptionStoreSchema>;

export const OrgSubscriptionDetailsSchema = z.object({
  plan: zMirageStudioSubscriptionPlan,
  frequency: z.enum(["monthly", "yearly"]),
  includedSeats: z.number(),
  cancelAtPeriodEnd: z.boolean(),
  // we might not know this for enterprise
  currentPeriodEnd: z.string().nullable(),
  // Which store actually entitles the org. Served by cap-srv today; it tells us
  // whether to send an operator to Stripe or to RevenueCat.
  store: SubscriptionStoreSchema.nullish(),
});
export type OrgSubscriptionDetailsType = z.infer<typeof OrgSubscriptionDetailsSchema>;
